export interface Product {
  priceId: string;
  productId: string;
  name: string;
  price: number;
  interval?: string;
  currency: string;
  mode: ProductModeEnum;
}

export enum ProductModeEnum {
  PAYMENT = 'payment',
  SUBSCRIPTION = 'subscription',
  FREE_TRIAL = 'freeTrial',
}
